// extracted by mini-css-extract-plugin
module.exports = {"split-heading":"split-heading_split-heading__fMjmS","center-on-mobile":"split-heading_center-on-mobile__dFwWv"};